if (!customElements.get('frame-finder-main')) {
    class FrameFinderMain extends HTMLElement {
        constructor() {
            super();
            this.requiredAnswers = this.dataset.requiredAnswers == "true";
            this.index = parseInt(this.dataset.index, 10);
            this.type = this.dataset.type;
            this.selectedAnswers = JSON.parse(localStorage.getItem('selected_answers')) || {};
            this.allSections = [];
        }

        connectedCallback() {
            // Popola l'array con tutte le sezioni
            this.allSections = [...document.querySelectorAll('frame-finder-main')];

            // Controlla se c'è un URL salvato nei cookie e inizia di conseguenza
            if (CookieUtils.getCookie('frame_finder_filter_url')) {
                this.initializeSections(this.type, false);
            } else {
                this.initializeSections(null, true);
            }

            // Gestione dei bottoni "Next"
            const nextButtons = this.querySelectorAll('.next-button'); 
            if (nextButtons.length > 0) {
                nextButtons.forEach(nextButton => {
                    nextButton.disabled = true; 
                    this.addOptionChangeListeners(nextButton); 

                    nextButton.addEventListener('click', () => {
                        this.handleNext(); 
                    });
                });
            }

            // Gestione dei bottoni "Prev"
            this.allSections.forEach(section => {
                const prevButton = section.querySelector('.prev-button');
                if (prevButton) {
                    prevButton.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.showPreviousSection(section);
                    });
                }
            });

            // Subscrive al cambiamento delle risposte
            subscribe(PUB_SUB_EVENTS.answerChanged, () => {
                this.updateVisibleAnswers();
            });

            // Aggiorna le risposte visibili
            this.updateVisibleAnswers();
        }

        // Aggiungi i listener per i cambi di opzione
        addOptionChangeListeners(nextButton) {
            const allOptions = this.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            allOptions.forEach(option => {
                option.addEventListener('change', () => {
                    const selectedOptions = this.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
                    nextButton.disabled = selectedOptions.length === 0;
                });
            });
        }

        // Mostra la sezione precedente
        showPreviousSection(section) {
            const index = parseInt(section.dataset.index);
            const previousSection = document.querySelector(`[data-index="${index - 1}"]`);
            
            if (previousSection) {
                previousSection.classList.add('active');
                section.classList.remove('active');
                
                // Controlla le risposte precedenti
                GetAnswer.checkPreviousAnswer.call(previousSection);
            }
        }

        // Inizializza le sezioni
        initializeSections(type = null, showQuestions = true) {
            if (type === "grid" && !showQuestions) {
                this.style.display = 'block';
                return;
            }
            if (showQuestions) {
                this.allSections.forEach((section, index) => {
                    section.style.display = index === 0 ? 'block' : 'none';
                    section.classList.toggle('active', index === 0);
                });
            }
        }

        // Ottieni l'indice della sezione attiva corrente
        getCurrentSectionIndex() {
            return this.allSections.findIndex(section => section.classList.contains('active'));
        }

        // Gestisci il passaggio alla sezione successiva
        handleNext() {
            const currentSectionIndex = this.getCurrentSectionIndex();
            const selectedOptions = this.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
        
            if (selectedOptions.length === 0) return;

            let concatenatedValues = [];
            selectedOptions.forEach(selectedOption => {
                const answerValue = selectedOption.value;
                const filterName = selectedOption.getAttribute('data-url');
                concatenatedValues.push({ value: answerValue, filterName });
        
                if (selectedOption.type === 'radio' && this.requiredAnswers) {
                    localStorage.setItem('last_answer', answerValue);
                }
            });
        
            this.updateAnswers(currentSectionIndex, concatenatedValues);
            this.resetNextSections(currentSectionIndex);
            this.navigateToNextSection(currentSectionIndex + 1);
            this.forceUpdateMatch(currentSectionIndex + 1, concatenatedValues.map(val => val.value).join(', '));
        }

        // Resetta le sezioni successive
        resetNextSections(currentSectionIndex) {
            for (let i = currentSectionIndex + 1; i < this.allSections.length; i++) {
                const section = this.allSections[i];
                section.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
                    input.checked = false;
                });
            }

            let selectedAnswers = JSON.parse(localStorage.getItem('selected_answers')) || {};
            for (let i = currentSectionIndex + 1; i < Object.keys(selectedAnswers).length; i++) {
                delete selectedAnswers[i];
            }
            localStorage.setItem('selected_answers', JSON.stringify(selectedAnswers));
            this.updateUrl();
        }

        // Passa alla sezione successiva
        navigateToNextSection(nextSectionIndex) {
            this.showSection(nextSectionIndex);
        }

        // Passa alla sezione precedente
        navigateToPreviousSection(prevSectionIndex) {
            this.showSection(prevSectionIndex);
        }

        // Mostra una specifica sezione
        showSection(sectionIndex) {
            const currentSection = this.allSections.find(section => section.classList.contains('active'));
            if (currentSection) {
                currentSection.classList.remove('active');
                currentSection.style.display = 'none';
            }

            const nextSection = this.allSections[sectionIndex];
            if (nextSection) {
                nextSection.classList.add('active');
                nextSection.style.display = 'block';
                this.forceUpdateMatch(sectionIndex);
            } 
        }

        // Aggiorna le risposte visibili
        updateVisibleAnswers() {
            const currentIndex = this.getCurrentSectionIndex();
            if (currentIndex < 0) return;

            const currentSection = this.allSections[currentIndex];
            const lastAnswer = localStorage.getItem('last_answer');
        
            if (!currentSection) {
                return;
            }
        
            const allOptions = currentSection.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            allOptions.forEach(option => {
                const previousAnswer = option.getAttribute('data-previous-answer');
                const optionBlock = option.closest('.get-answer') || option.parentElement.closest('.get-answer') || option.parentElement;

                if (!option.value) return;

                if (optionBlock) {
                    if (!previousAnswer || previousAnswer === lastAnswer) {
                        optionBlock.style.display = 'block';
                    }

                    if (option.checked) {
                        optionBlock.style.display = 'block';
                    }
                }
            });

            // Controllo per aggiornare le risposte precedenti
            if (currentIndex > 0) {
                const prevSectionIndex = currentIndex - 1;
                const prevAnswer = localStorage.getItem(`section-${prevSectionIndex}-answer`);
                if (prevAnswer) {
                    this.forceUpdateMatch(prevSectionIndex, prevAnswer);
                }
            }
        }

        // Aggiorna le risposte selezionate
        updateAnswers(sectionIndex, answerValues) {
            let selectedAnswers = JSON.parse(localStorage.getItem('selected_answers')) || {};

            if (Array.isArray(answerValues)) {
                selectedAnswers[sectionIndex] = answerValues.map(val => `${val.filterName}${val.value}`).join('&');
            } else {
                selectedAnswers[sectionIndex] = `${answerValues.filterName}${answerValues.value}`;
            }

            localStorage.setItem('selected_answers', JSON.stringify(selectedAnswers));
            this.updateUrl();
        }

        // Aggiorna l'URL
        updateUrl() {
            let currentUrl = '';
            const selectedAnswers = JSON.parse(localStorage.getItem('selected_answers')) || {};

            for (const index in selectedAnswers) {
                currentUrl += `${selectedAnswers[index]}&`;
            }

            currentUrl = currentUrl.slice(0, -1);
            localStorage.setItem('current_url', currentUrl);

        }

        // Forza l'aggiornamento del match delle opzioni
        forceUpdateMatch(sectionIndex, answerValue = null) {
            const lastAnswer = answerValue || localStorage.getItem('last_answer');
            const currentSection = this.allSections[sectionIndex];
            const prevSectionIndex = sectionIndex - 1;
        
            if (!currentSection) return;

            const previousAnswer = localStorage.getItem(`section-${prevSectionIndex}-answer`);
        
            const allOptions = currentSection.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            allOptions.forEach(option => {
                const optionPreviousAnswer = option.getAttribute('data-previous-answer');
                const optionBlock = option.closest('.get-answer');

                if (optionBlock) {
                    if (!previousAnswer || previousAnswer === lastAnswer) {
                        optionBlock.style.display = 'block';
                    } else if (!option.checked) {
                        optionBlock.style.display = 'none';
                    }
                
                    if (option.checked) {
                        optionBlock.style.display = 'block';
                    }
                }
            });
        }
    }

    customElements.define('frame-finder-main', FrameFinderMain);
}